/* Manchester · 2026-05-15 — PLP card swatch → image swap on hover/click.

   Cuando el usuario pasa mouse sobre un swatch de color en una product card
   de PLP/home, la imagen principal del card cambia a la imagen del variant
   correspondiente. UX común en moda (Zara, ASOS, Massimo Dutti).

   Implementación:
   - Cada .product-block-options__item tiene <img> miniatura con la
     featured_media del variant. Reusamos ese filename + reconstruimos la URL
     manteniendo el width/quality del main card img → main img cambia.
   - mouseenter swatch → swap. mouseleave card → restore original.
   - touchstart swatch → swap permanent (sin restore, mobile esperado).
*/
(function () {
  'use strict';

  var ITEM_SEL = '.product-block-options__item';
  var CARD_SEL = 'product-block, .product-block';

  function getCard(el) { return el.closest(CARD_SEL); }
  // Manchester · 2026-05-15 — cards tienen 2 imágenes (main + hover-image)
  // dentro de .img-ar. Symmetry hace cross-fade native entre las dos en hover
  // del card. Necesitamos swapear AMBAS para que el cambio sea visible.
  function getMainImgs(card) {
    var imgs = Array.from(card.querySelectorAll('img')).filter(function (i) {
      // Skip swatch thumbnails (small, inside .product-block-options__item)
      if (i.closest('.product-block-options__item')) return false;
      // Only meaningful product images (filter out icons, etc.)
      return (i.naturalWidth || 0) > 100 || i.closest('.img-ar, .product-block-image, .product-block__image');
    });
    return imgs;
  }

  function getSwatchFilename(swatchItem) {
    var img = swatchItem.querySelector('img');
    if (!img) return null;
    var src = img.currentSrc || img.src;
    if (!src) return null;
    try {
      var u = new URL(src);
      return u.pathname.split('/').pop();
    } catch (e) { return null; }
  }

  function replaceFilenameInUrl(url, newFilename) {
    try {
      var u = new URL(url, location.origin);
      var parts = u.pathname.split('/');
      parts[parts.length - 1] = newFilename;
      u.pathname = parts.join('/');
      return u.toString();
    } catch (e) { return url; }
  }

  function swapToFilename(mainImg, newFilename) {
    if (!mainImg || !newFilename) return;
    // Save original for restore
    if (!mainImg.dataset.mfgOriginalSrc) {
      mainImg.dataset.mfgOriginalSrc = mainImg.src;
      mainImg.dataset.mfgOriginalSrcset = mainImg.srcset || '';
    }
    // Replace src
    mainImg.src = replaceFilenameInUrl(mainImg.src, newFilename);
    // Replace each URL in srcset (preserves the descriptor widths)
    if (mainImg.srcset) {
      var newSrcset = mainImg.srcset.split(',').map(function (part) {
        var trimmed = part.trim();
        var spaceIdx = trimmed.lastIndexOf(' ');
        var url = spaceIdx > 0 ? trimmed.slice(0, spaceIdx) : trimmed;
        var descriptor = spaceIdx > 0 ? trimmed.slice(spaceIdx) : '';
        return replaceFilenameInUrl(url, newFilename) + descriptor;
      }).join(', ');
      mainImg.srcset = newSrcset;
    }
  }

  function restoreOriginal(mainImg) {
    if (!mainImg || !mainImg.dataset.mfgOriginalSrc) return;
    mainImg.src = mainImg.dataset.mfgOriginalSrc;
    if (mainImg.dataset.mfgOriginalSrcset) {
      mainImg.srcset = mainImg.dataset.mfgOriginalSrcset;
    }
  }

  // Hover swap (desktop)
  document.addEventListener('mouseover', function (evt) {
    var item = evt.target.closest(ITEM_SEL);
    if (!item) return;
    var card = getCard(item);
    if (!card) return;
    var mainImgs = getMainImgs(card);
    if (!mainImgs.length) return;
    var fname = getSwatchFilename(item);
    if (!fname) return;
    mainImgs.forEach(function (img) { swapToFilename(img, fname); });
  });

  // Restore when mouse leaves card (not just swatch — gives smoother UX)
  document.addEventListener('mouseleave', function (evt) {
    var card = evt.target.closest && evt.target.closest(CARD_SEL);
    if (!card) return;
    var mainImgs = getMainImgs(card);
    mainImgs.forEach(restoreOriginal);
  }, true); // capture phase para mouseleave en cualquier card descendant

  // Touch: tap → swap permanente (no restore, esperado UX mobile)
  document.addEventListener('touchstart', function (evt) {
    var item = evt.target.closest(ITEM_SEL);
    if (!item) return;
    var card = getCard(item);
    if (!card) return;
    var mainImgs = getMainImgs(card);
    if (!mainImgs.length) return;
    var fname = getSwatchFilename(item);
    if (!fname) return;
    // Persist: clear original so subsequent hover doesn't restore
    mainImgs.forEach(function (img) {
      img.dataset.mfgOriginalSrc = '';
      img.dataset.mfgOriginalSrcset = '';
      swapToFilename(img, fname);
    });
  }, { passive: true });
})();
